<template>
    <div class="avatar-box m-2 d-flex justify-content-center">
        <vue-ellipse-progress
            :progress="progress"
            :size="220"
            :legend="false"
            emptyColor="#B6A3FF"
            :color="gradient"
            dot="30 #FFB600"
            >
             <div slot="legend-caption">
                <div :id="avatar.id">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${avatar.name}/${avatar.value}`"
                        class="transition-all mt-2"
                        alt="Avatar"
                        height="170"
                        width="170"
                    />
                </div>
             </div>
        </vue-ellipse-progress>
    </div>
</template>

<script>
const defaultAvatar = () => {
    return {
        active: false,
        avatarFormat: '',
        avatarPack: null,
        creationDate: null,
        id: 0,
        name: '',
        ordinalAvatarFormat: 1,
        value: ''
    }
}

export default {
    props: {
        avatar: {
            type: Object,
            default: defaultAvatar,
        },
        progress: Number
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            }
        }
    }
}
</script>

<style lang="css" scoped>

.avatar-box {
    padding-top: 10px;
    border-radius: 500px;   
}

.avatar-box,
.avatar-image {
    border-radius: 500px;
}
</style>
